module.exports = __webpack_public_path__ + "static/media/logo-blanc-groc.ef0029b8.png";